import {
  useLoaderData,
  useOutletContext,
  useParams,
  Link,
} from "react-router-dom";

import { PageProps } from "../../services/Common/interfaces";
import NotesTab from "../../../unified-dashboard/src/pages/NotesTab";
import { LeadsService } from "../../services/Leads";

export async function leadsNotesLoader({ params, getToken, pageName }: any) {
  const { userID } = params;
  const payload = {
    token: getToken(),
    pageName,
    userID: userID,
  };
  const response = await LeadsService.getNotes(payload);

  return {
    notesResponse: response,
  };
}

function LeadsNotes({ pageName }: PageProps) {
  const { sourceEntityID, programID, userID } = useParams();
  const { notesResponse } = useLoaderData() as any;
  const { whiteLabelStyle }: any = useOutletContext();

  const HREF = `/leads/details/${sourceEntityID}/${programID}/${userID}/notes`;

  return (
    <NotesTab
      href={HREF}
      whiteLabelStyle={whiteLabelStyle}
      notes={notesResponse?.data?.notes ?? []}
      isLenderPlatform={false}
      link={Link}
    />
  );
}

export default LeadsNotes;
